import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { AppProvider } from './context/AppProvider';
import MainLayout from './components/Layout/MainLayout';
import CheckoutBuilder from './pages/CheckoutBuilder';
import AnalyticsPage from './pages/AnalyticsPage';
import OrderConfirmationBuilder from './pages/OrderConfirmationBuilder';
import theme from './theme';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: false,
      staleTime: 1000 * 60 * 5, // 5 minutes`
      gcTime: 1000 * 60 * 10, // 10 minutes
    },
  },
})

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <AppProvider>
          <Router>
            <MainLayout>
              <Routes>
                <Route path="/" element={<Navigate to="/checkout" replace />} />
                <Route path="/checkout" element={<CheckoutBuilder />} />
                <Route path="/analytics" element={<AnalyticsPage />} />
                <Route path="/order-confirmation" element={<OrderConfirmationBuilder />} />
              </Routes>
            </MainLayout>
          </Router>
        </AppProvider>
      </ThemeProvider>
    </QueryClientProvider>
  );
}

export default App;
